module.exports = __webpack_public_path__ + "img/02.509011b1.jpg";